










































import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';
import AppComboBox from '@/uikit/components/AppComboBox/AppComboBox.vue';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import { getEventsData } from '@/services';
import { debounce } from 'lodash';

export default {
  name: 'QuickFilter',
  components: { AppComboBox, AppButtonNew, AppSelect: AppComboBox },
  inject: ['$api'],
  props: {
    cfg: {
      type: Object as () => LayoutConfig['content']['startPage']['sections']['quickFilter'],
      required: true,
    },
    data: {
      type: Object as () => LayoutDataSet['quickFilter'],
    },
  },
  data() {
    return {
      filterRoute: {
        name: 'events',
        params: {},
        path: '/directivities',
      },
      filtered: 0,
      dataValues: {
        cat_edu: '',
        industry: '',
        profession: '',
        form_education: '',
      },
    };
  },
  watch: {
    values: {
      handler() {
        let sendData = {
          page: 1,
          limit: 100,
          cat_edu: this.dataValues.cat_edu ?? undefined,
          industry: this.dataValues.industry ?? undefined,
          profession: this.dataValues.profession ?? undefined,
          form_education: this.dataValues.form_education ?? undefined,
        };
        this.debounceCalc(sendData);
      },
    },
  },
  mounted() {
    this.calcFiltered({ page: 1, limit: 100 });
  },
  methods: {
    redirectThis() {
      this.$router.push({
        ...this.filterRoute,
        query: Object.keys(this.dataValues)
          .filter(
            (item) =>
              this.dataValues[item] !== undefined &&
              this.dataValues[item] !== null
          )
          .reduce((res: any, item) => {
            res[item] = this.dataValues[item];
            return res;
          }, {}),
      });
    },
    calcFiltered(sendData: any) {
      getEventsData(this.$api)
        .getEvents(sendData)
        .then((result: any) => {
          this.filtered = result.filtered;
        });
    },
  },
  computed: {
    debounceCalc() {
      return debounce(this.calcFiltered, 100);
    },
    values() {
      return [
        this.dataValues.cat_edu,
        this.dataValues.industry,
        this.dataValues.profession,
        this.dataValues.form_education,
      ];
    },
    //cat_edu
    get1BoxData() {
      return [
        { id: '', text: 'Не выбрано' },
        ...this.$store.state.educationCategories.map(
          ({ id = String, name = String }) => {
            return { id, text: name };
          }
        ),
      ];
    },
    // industry
    get2BoxData() {
      return [
        { id: '', text: 'Не выбрано' },
        ...this.$store.state.industries.map(
          ({ id = String, name = String }) => {
            return { id, text: name };
          }
        ),
      ];
    },
    // profession
    get3BoxData() {
      return [
        { id: '', text: 'Не выбрано' },
        ...this.$store.state.professions
          .map((elem: any) => {
            return { ...elem, id: elem.id, text: elem.name };
          })
          .filter((item: any) => {
            return (
              item.default ||
              !this.dataValues.industry ||
              item.industries.includes(this.dataValues.industry)
            );
          }),
      ];
    },
    // form_education
    get4BoxData() {
      return [
        { id: '', text: 'Не выбрано' },
        ...this.$store.state.educationForms.map(
          ({ id = Number, name = String }) => {
            return { id, text: name };
          }
        ),
      ];
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/quickFilter/QuickFilter.vue